import React, { useState } from 'react';
import { ReactFormBuilder } from 'react-form-builder2';

import { useFormBuilderContext } from 'lib/context/FormBuilder/FormBuilderContext';

import { FormBuilderToolbar } from 'components/shared/Forms/Custom/Register';

import { getCurrentStep, getStepsLeft } from '../../lib/helpers';

import Header from './components/Header';
import Preview from './components/Preview';

const Builder = ({ currentBreadcrumb, formTypes }) => {
  const [previewMode, setPreviewMode] = useState(false);
  const [disabledPreview, setDisabledPreview] = useState(true);
  const { breadCrumbs, formChange, formik } = useFormBuilderContext();
  const currentBreadcrumbStep = getCurrentStep(breadCrumbs, currentBreadcrumb);
  const getBreadcrumbsLeft = getStepsLeft(breadCrumbs, currentBreadcrumb);
  const chartData = [
    { name: 'completed', value: currentBreadcrumbStep, fills: '#4ADE80' },
    { name: 'not-completed', value: getBreadcrumbsLeft, fills: '#fff' }
  ];

  return (
    <div className="flex h-full flex-col">
      {previewMode ? (
        <Preview
          setPreviewMode={setPreviewMode}
          disabledPreview={disabledPreview}
          setDisabledPreview={setDisabledPreview}
        />
      ) : (
        <>
          <Header
            chartData={chartData}
            currentBreadcrumbStep={currentBreadcrumbStep}
            getBreadcrumbsLeft={getBreadcrumbsLeft}
            setPreviewMode={setPreviewMode}
            disabledPreview={!formik?.values?.form?.json?.fields}
            setDisabledPreview={setDisabledPreview}
            typeOptions={formTypes}
          />
          <ReactFormBuilder
            onPost={(e) => formChange(e.task_data)}
            data={formik?.values?.form?.json?.fields ? formik?.values?.form?.json?.fields : null}
            toolbarItems={FormBuilderToolbar}
          />
        </>
      )}
    </div>
  );
};

export default Builder;
